import {clear as init} from 'ui/keyboard';
import {InputMode} from './const';

export const initialUserInputState: UserInputState = {
  inputMode: InputMode.Spend,
  keyboard: init(),
};
